import { configureStore, combineReducers } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import businessIdeaReducer from './slices/businessIdeaSlice';

/// Create root reducer
const appReducer = combineReducers({
  user: userReducer,
  businessIdea: businessIdeaReducer
});

// Add a root-level reducer to handle logout
const rootReducer = (state, action) => {
  // Clear all redux state when logout action is dispatched
  if (action.type === 'user/logout') {
    state = '';
  }
  return appReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});

// Optional: Add a listener to localStorage changes
window.addEventListener('storage', (e) => {
  // If authToken is removed from localStorage, dispatch logout
  if (e.key === 'authToken' && !e.newValue) {
    store.dispatch({ type: 'user/logout' });
  }
});

export default store;
